import React, { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NovoDiario from "./pages/NovoDiario";
import Legal from "./pages/Legal";
import Ativar from "./pages/Ativar";
import RedefinirSenha from "./pages/RedefinirSenha";
import Paciente from "./pages/Paciente";
import Plano from "./pages/Plano";
import Admin from "./pages/Admin";

const Acompanhamento = lazy(() => import("./pages/Acompanhamento"));

function Protected({ children }) {
  const { user, loading } = useAuth();
  return loading ? <div className="estado-pagina">Carregando…</div> : user ? children : <Navigate to="/entrar" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<div className="estado-pagina">Carregando…</div>}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/entrar" element={<Login />} />
            <Route path="/ativar" element={<Ativar />} />
            <Route path="/redefinir-senha" element={<RedefinirSenha />} />
            <Route path="/paciente" element={<Paciente />} />
            <Route path="/privacidade" element={<Legal tipo="privacidade" />} />
            <Route path="/termos" element={<Legal tipo="termos" />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/novo" element={<Protected><NovoDiario /></Protected>} />
            <Route path="/app/acompanhamentos/:id" element={<Protected><Acompanhamento /></Protected>} />
            <Route path="/app/plano" element={<Protected><Plano /></Protected>} />
            <Route path="/app/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}
